import React from 'react';
import { useIntl } from 'react-intl';
import Media from 'react-media';

import { IconRegularClose, theme } from '@notino/react-styleguide-v20';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { trackCouponRemovedEvent } from '@services/ecommerceService';
import { BenefitItem, StyledVoucherWithCode } from '@sharedComponents/Benefits';
import { GridDivider } from '@sharedComponents/Separators';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';
import { getNumberInNegative } from '@utils/math';
import { CypressTestNamespace } from '@utils/test';

import { useCartPageContext } from '../../../context';
import { messages } from '../messages';

import { b } from './componentHelpers';
import { shouldRenderVoucher } from './utils';

export const VoucherList: ReactFCV = () => {
  const {
    state: { benefits, products },
    actions: { removeVoucher },
  } = useCartPageContext();

  const {
    applicationSettings: { secondaryCurrency },
  } = useApplicationRuntimeContext();

  const isDualPriceLayout = Boolean(secondaryCurrency);

  const { formatMessage } = useIntl();

  const onRemovedVoucher = (code: string) => {
    removeVoucher({ code: code });
    trackCouponRemovedEvent({ name: code.toLowerCase() });
  };

  return (
    <>
      {benefits.vouchers.map(
        (voucher) =>
          shouldRenderVoucher(voucher, benefits, products) && (
            <React.Fragment key={voucher.code}>
              <BenefitItem
                isDualPriceLayout={isDualPriceLayout}
                dataTestId={CypressTestNamespace.ECartPageCoupons.COUPON_CODE_LIST_ITEM}
                value={voucher.isDeliveryVoucher ? 0 : getNumberInNegative(voucher.value)}
                onClick={() => {
                  onRemovedVoucher(voucher.code);
                }}
                buttonContent={
                  voucher.isDeliveryVoucher ? (
                    ''
                  ) : (
                    <Media query={`(max-width: ${theme.breakpoints.sm ?? ''}rem)`}>
                      {(matches) =>
                        matches ? (
                          <IconRegularClose color={'icon.tertiary'} width="14px" height="14px" />
                        ) : (
                          formatMessage(messages.voucherRemoveButtonText)
                        )
                      }
                    </Media>
                  )
                }
                buttonContextHelp={formatMessage(messages.voucherRemoveButtonHelpText)}
                title={
                  voucher.isDeliveryVoucher ? (
                    formatMessage(messages.voucherFreeDeliveryText, { b })
                  ) : (
                    <StyledVoucherWithCode>
                      {formatMessage(messages.voucherAppliedVoucherText, { b, voucherCode: voucher.code })}
                    </StyledVoucherWithCode>
                  )
                }
                isVoucher={true}
              />
              <GridDivider color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />
            </React.Fragment>
          ),
      )}
    </>
  );
};
